import { parentList } from "@/api/product/parent";

/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
  let search = params;
  search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
  dateRange = Array.isArray(dateRange) ? dateRange : [];
  if (typeof (propName) === 'undefined') {
    search.params['beginTime'] = dateRange[0];
    search.params['endTime'] = dateRange[1];
  } else {
    search.params['begin' + propName] = dateRange[0];
    search.params['end' + propName] = dateRange[1];
  }
  return search;
}

// 回显数据字典 
export function selectDictLabel(datas, value) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  Object.keys(datas).some((key) => {
    if (datas[key].value == ('' + value)) {
      actions.push(datas[key].label);
      return true;
    }
  })
  if (actions.length === 0) {
    actions.push(value);
  }
  return actions.join('');
}

// 回显数据字典（字符串数组）
export function selectDictLabels(datas, value, separator) {
  if (value === undefined) {
    return "";
  }
  var actions = [];
  var currentSeparator = undefined === separator ? "," : separator;
  var temp = value.split(currentSeparator);
  Object.keys(value.split(currentSeparator)).some((val) => {
    var match = false;
    Object.keys(datas).some((key) => {
      if (datas[key].value == ('' + temp[val])) {
        actions.push(datas[key].label + currentSeparator);
        match = true;
      }
    })
    if (!match) {
      actions.push(temp[val] + currentSeparator);
    }
  })
  return actions.join('').substring(0, actions.join('').length - 1);
}

// 字符串格式化(%s )
export function sprintf(str) {
  var args = arguments, flag = true, i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty(str) {
  if (!str || str == "undefined" || str == "null") {
    return "";
  }
  return str;
}

// 数据合并
export function mergeRecursive(source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p]);
      } else {
        source[p] = target[p];
      }
    } catch (e) {
      source[p] = target[p];
    }
  }
  return source;
};

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree(data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children'
  };

  var childrenListMap = {};
  var nodeIds = {};
  var tree = [];

  for (let d of data) {
    let parentId = d[config.parentId];
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = [];
    }
    nodeIds[d[config.id]] = d;
    childrenListMap[parentId].push(d);
  }

  for (let d of data) {
    let parentId = d[config.parentId];
    if (nodeIds[parentId] == null) {
      tree.push(d);
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t);
  }

  function adaptToChildrenList(o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]];
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c);
      }
    }
  }
  return tree;
}

/**
* 参数处理
* @param {*} params  参数
*/
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate(data) {
  try {
    const text = await data.text();
    JSON.parse(text);
    return false;
  } catch (error) {
    return true;
  }
}


export function watermark(settings) {
  //默认设置
  var defaultSettings = {
    watermarl_element: "body",
    watermark_txt: "",
    watermark_x: 10,//水印起始位置x轴坐标
    watermark_y: 10,//水印起始位置Y轴坐标
    watermark_rows: 2000,//水印行数
    watermark_cols: 2000,//水印列数
    watermark_x_space: 50,//水印x轴间隔
    watermark_y_space: 50,//水印y轴间隔
    watermark_color: '#d7d7d7',//水印字体颜色
    watermark_alpha: 0.5,//水印透明度
    watermark_fontsize: '12px',//水印字体大小
    watermark_font: '微软雅黑',//水印字体
    watermark_width: 500,//水印宽度
    watermark_height: 50,//水印长度
    watermark_angle: 15//水印倾斜度数
  };
  //采用配置项替换默认值，作用类似jquery.extend
  if (arguments.length === 1 && typeof arguments[0] === "object") {
    var src = arguments[0] || {};
    for (key in src) {
      if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) {
        continue;
      } else if (src[key]) {
        defaultSettings[key] = src[key];
      }
    }
  }

  var oTemp = document.createDocumentFragment();

  var maskElement = document.getElementById(defaultSettings.watermarl_element) || document.body;
  //获取页面最大宽度
  var page_width = Math.max(maskElement.scrollWidth, maskElement.clientWidth);
  //获取页面最大高度
  var page_height = Math.max(maskElement.scrollHeight, maskElement.clientHeight, maskElement.scrollTop);
  //水印数量自适应元素区域尺寸
  defaultSettings.watermark_cols = Math.ceil(page_width / (defaultSettings.watermark_x_space + defaultSettings.watermark_width));
  defaultSettings.watermark_rows = Math.ceil(page_height / (defaultSettings.watermark_y_space + defaultSettings.watermark_height));
  var x;
  var y;
  for (var i = 0; i < defaultSettings.watermark_rows; i++) {
    y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i;
    for (var j = 0; j < defaultSettings.watermark_cols; j++) {
      x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j;
      var mask_div = document.createElement('div');
      mask_div.id = 'mask_div' + i + j;
      mask_div.className = 'mask_div';
      //mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt));
      mask_div.innerHTML = (defaultSettings.watermark_txt);
      //设置水印div倾斜显示
      mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.visibility = "";
      mask_div.style.position = "absolute";
      mask_div.style.left = x + 'px';
      mask_div.style.top = y + 'px';
      mask_div.style.overflow = "hidden";
      mask_div.style.zIndex = "1029"; // 9999
      // pointer-events:none  让水印不遮挡页面的点击事件
      mask_div.style.pointerEvents = 'none';
      // 设置边框
      // mask_div.style.border="solid #eee 1px";
      // 兼容IE9以下的透明度设置
      mask_div.style.filter = "alpha(opacity=50)";
      mask_div.style.opacity = defaultSettings.watermark_alpha;
      mask_div.style.fontSize = defaultSettings.watermark_fontsize;
      mask_div.style.fontFamily = defaultSettings.watermark_font;
      mask_div.style.color = defaultSettings.watermark_color;
      mask_div.style.textAlign = "center";
      mask_div.style.width = defaultSettings.watermark_width + 'px';
      mask_div.style.height = defaultSettings.watermark_height + 'px';
      mask_div.style.display = "block";
      oTemp.appendChild(mask_div);
    };
  };
  maskElement.appendChild(oTemp);
}

/**
 * 复制内容到剪切板
 * @param {*} content 
 * @returns 
 */
export function copyToClipboard(content = '') {
  if (!content) {
    return false
  }
      const textarea = document.createElement('textarea');
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      return true
}

/**
 * 节流函数（带定时器实现）
 * @param {Function} func - 要执行的函数
 * @param {Number} wait - 规定时间间隔（单位：毫秒）
 * @returns {Function} - 返回被节流处理后的函数
 */
export function throttle(func, wait) {
  let timeout = null;
  let lastExecutionTime = 0;

  return function (...args) {
    const now = Date.now();
    const remainingTime = wait - (now - lastExecutionTime);
    timeout && clearTimeout(timeout);

    // 如果超过时间间隔就直接触发函数
    if (remainingTime <= 0) {
      timeout = null;
      lastExecutionTime = now;
      func.apply(this, args);

    } else if (!timeout) {
      // 如果还有剩余时间，让最后一轮触发执行一次
      timeout = setTimeout(() => {
        lastExecutionTime = Date.now();
        timeout = null;
        func.apply(this, args);
      }, remainingTime);
    }
  };
}


/**
 * 获取项目列表
 */
export function getProducts(key = '') {
  return new Promise((resolve, reject) => {
    var data = {
        pageNum: 1,
        pageSize: 9999,
        name: "",
    };
    parentList(data).then((res) => {
        resolve(res.rows.filter(i => key ? i[key] : true))
    }).catch(err => {
      reject(err)
    });
  })
}

export function checkOverlap(val1, condition1, val2, condition2) {
  // 检查两个条件是否存在并集
  const conditions = {
      gt: (a, b) => a < b, // val1 < val2
      gte: (a, b) => a <= b,
      lt: (a, b) => a > b, // val1 > val2
      lte: (a, b) => a >= b,
      eq: (a, b) => a === b
  }
  
  // 检查两个条件是否互斥
  const isExclusive = (
      (condition1 === 'gt' && condition2 === 'lt') ||
      (condition1 === 'gt' && condition2 === 'lte') ||
      (condition1 === 'gte' && condition2 === 'lt') ||
      (condition1 === 'lt' && condition2 === 'gt') ||
      (condition1 === 'lt' && condition2 === 'gte') ||
      (condition1 === 'lte' && condition2 === 'gt') ||
      (condition1 === 'gte' && condition2 === 'lte') ||
      (condition1 === 'lte' && condition2 === 'gte')
  )
  
  if (isExclusive) {
      // 如果条件互斥，检查值是否导致并集
      return conditions[condition1](val1, val2)
  }
  
  // 检查相同类型的条件
  if (condition1 === condition2) {
      return true
  }
  
  // 检查不同但可能重叠的条件
  if ((condition1 === 'gt' || condition1 === 'gte') && (condition2 === 'gt' || condition2 === 'gte')) {
      return true
  }
  if ((condition1 === 'lt' || condition1 === 'lte') && (condition2 === 'lt' || condition2 === 'lte')) {
      return true
  }
  
  return false
}

/**
 * 时区 使用页面，拍脸图，现金积分
 * @returns 
 */
export function timeZoneList() {
  return [
    {
        "key": "8",
        "value": "UTC +8"
    },
    {
        "key": "12",
        "value": "UTC +12"
    },
    {
        "key": "11",
        "value": "UTC +11"
    },
    {
        "key": "10",
        "value": "UTC +10"
    },
    {
        "key": "9",
        "value": "UTC +9"
    },
    {
        "key": "7",
        "value": "UTC +7"
    },
    {
        "key": "6",
        "value": "UTC +6"
    },
    {
        "key": "5",
        "value": "UTC +5"
    },
    {
        "key": "4",
        "value": "UTC +4"
    },
    {
        "key": "3",
        "value": "UTC +3"
    },
    {
        "key": "2",
        "value": "UTC +2"
    },
    {
        "key": "1",
        "value": "UTC +1"
    },
    {
        "key": "-1",
        "value": "UTC -1"
    },
    {
        "key": "-2",
        "value": "UTC -2"
    },
    {
        "key": "-3",
        "value": "UTC -3"
    },
    {
        "key": "-4",
        "value": "UTC -4"
    },
    {
        "key": "-5",
        "value": "UTC -5"
    },
    {
        "key": "-6",
        "value": "UTC -6"
    },
    {
        "key": "-7",
        "value": "UTC -7"
    },
    {
        "key": "-8",
        "value": "UTC -8"
    },
    {
        "key": "-9",
        "value": "UTC -9"
    },
    {
        "key": "-10",
        "value": "UTC -10"
    },
    {
        "key": "-11",
        "value": "UTC -11"
    },
    {
        "key": "-12",
        "value": "UTC -12"
    }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/ruoyi.js